import { AppButton } from "../ui/AppButton.js";
import { messages } from "../../i18n/messages.js";

interface CatalogEmptyStateProps {
  query: string;
  category?: string | null;
  onReset?: () => void;
}

export function CatalogEmptyState({ query, category = null, onReset }: CatalogEmptyStateProps) {
  const hasQuery = query.trim().length > 0;
  const hasCategory = Boolean(category?.trim());

  const title = hasQuery
    ? messages.catalog.emptySearchTitle
    : hasCategory
      ? messages.catalog.emptyCategoryTitle
      : messages.catalog.emptyTitle;
  const body = hasQuery
    ? messages.catalog.emptySearchBody
    : hasCategory
      ? messages.catalog.emptyCategoryBody
      : messages.catalog.emptyBody;

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-3 px-6 py-12 text-center">
      <h3 className="text-base font-semibold">{title}</h3>
      <p className="max-w-xs text-sm opacity-70">{body}</p>
      {onReset ? (
        <AppButton variant="secondary" onClick={onReset}>
          {messages.catalog.resetFilters}
        </AppButton>
      ) : null}
    </div>
  );
}
